/*@flow*/
import type { Node } from 'react';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import Category, { type CategoryT } from './Category';
import Custom, { type CustomT } from './Custom';
import Gradient, { type GradientT } from './Gradient';
import Markup, { type MarkupT } from './Markup';
export type LegendT = CustomT | CategoryT | GradientT | MarkupT;
import { StackContext } from './contexts';
import useLegends from '../useLegends';
import history from 'lib/history';

const Component = ({ open }: { open: ?boolean }): null | Node => {
  const legends = useLegends();

  const [historyShot, setHistoryShot] = useState(legends);
  const [filters, setFilters] = useState(history.getQuery().filter);
  const [internalUpdate, setInternalUpdate] = useState(false);
  const updateNumber =
    legends.size +
    _.get(legends, ['_tail', 'array', 'length'], 0) +
    _.get(legends, ['_tail', 'array'], []).reduce(
      (acc, num) => acc + _.get(num, ['colorDomain', 'length'], 0),
      0
    ) +
    _.get(legends, ['_tail', 'array'], []).reduce(
      (acc, num) => acc + _.get(num, ['colorRange', 'length'], 0),
      0
    );

  useEffect(() => {
    if (internalUpdate) {
      setInternalUpdate(false);
    } else {
      setFilters(history.getQuery().filter);
      setHistoryShot(legends);
    }
  }, [updateNumber]);

  if (!open) return null;
  if (!historyShot) return null;
  if (historyShot.isEmpty()) return null;

  return (
    <StackContext.Provider value={historyShot}>
      <div className="legend-panels">
        <Category
          setInternalUpdate={setInternalUpdate}
          internalUpdate={internalUpdate}
          filters={filters}
        />
        <Custom
          setInternalUpdate={setInternalUpdate}
          internalUpdate={internalUpdate}
          filters={filters}
        />
        <Gradient
          setInternalUpdate={setInternalUpdate}
          internalUpdate={internalUpdate}
          filters={filters}
        />
        <Markup
          setInternalUpdate={setInternalUpdate}
          internalUpdate={internalUpdate}
          filters={filters}
        />
      </div>
    </StackContext.Provider>
  );
};
export default Component;
